export interface Owner {
  userId: number;
  firstName: string;
  lastName: string;
  emailAddress: string;
  prefix?: string;
  title?: string;
}

export function copyOwner(owner: Owner): Owner {
  return {
    emailAddress: owner.emailAddress,
    firstName: owner.firstName,
    lastName: owner.lastName,
    prefix: owner.prefix,
    title: owner.title,
    userId: owner.userId,
  }
}

export function blankOwner(): Owner {
  return {
    userId: 0,
    firstName: '',
    lastName: '',
    emailAddress: ''
  };
}
